export default {"src":"/_next/static/media/PropertyPalLogo.b096cb16.svg","height":376,"width":1028,"blurWidth":0,"blurHeight":0};